import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import useSeo from "@/hooks/useSeo";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function NotFound() {
  useSeo({
    title: "页面不存在 | 黑料热点",
    description:
      "你访问的页面不存在或已被调整。可以返回首页，或浏览已完成时间线梳理的热点事件复盘，继续追踪你关心的事件脉络。",
    canonicalPath: "/",
  });

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-20 text-center md:px-8">
            <span className="font-heading text-6xl font-black text-primary-500 md:text-8xl">404</span>
            <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              这个页面不见了
            </h1>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
              你要找的页面可能已改名、合并到其他复盘，或者链接输错了。
              不如回到首页或复盘列表，继续看你关心的事件脉络。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                返回首页
              </Link>
              <Link
                to="/topics"
                className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                浏览复盘列表
              </Link>
            </div>
          </div>
        </section>

        <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-14">
          <h2 className="font-heading text-xl font-bold text-foreground-950">也许你会感兴趣</h2>
          <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {topics.slice(0, 3).map((topic) => (
              <TopicCard key={topic.id} topic={topic} />
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}